$("#myModal").ready(function () {
  let modal = document.getElementById("myModal");
  if (!modal) return;

  let closeBtn = document.getElementById("closePopup");
  let close = document.getElementById("continue-browsing");

  if (close) {
    close.onclick = function () {
      modal.style.display = "none";
      $.cookie("LOC", "auth", {
        expires: 30,
        path: "/",
      });
    };
  }
  if (closeBtn) {
    closeBtn.onclick = function () {
      modal.style.display = "none";
      $.cookie("LOC", "auth", {
        expires: 30,
        path: "/",
      });
    };
  }

  checkLoc();
});

function checkLoc() {
  $.getJSON(
    "https://geolocation-db.com/json/85249190-4601-11eb-9067-21b51bc8dee3",
    function (response) {
      if (response.country_code != "CA") {
        let modal = document.getElementById("myModal");
        if (!modal) return;

        let LOC = $.cookie("LOC");

        if (LOC == "auth") {
          modal.style.display = "none";
        } else {
          modal.style.display = "block";
          $.cookie("LOC", "unauth", {
            expires: 30,
            path: "/",
          });
        }
      }
    }
  );
}
